import { ProgressBar } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Stack, SxProps, Theme, Typography } from '@mui/material';

const LIFE_READINESS_STRINGS = appStrings.modules.lifeReadiness;

const LEVEL_MAP = {
  level1_count: '1',
  level2_count: '2',
  level3_count: '3',
  level4_count: '4',
  total: 'total',
} as const;

const LEVEL_KEYS = Object.keys(LEVEL_MAP) as (keyof typeof LEVEL_MAP)[];

export type SubCategoryProgressGroupProps = Readonly<{
  progressBars: Record<
    string,
    {
      [key in keyof typeof LEVEL_MAP]: number;
    }
  >;
}>;

export const SubCategoryProgressGroup = ({ progressBars }: SubCategoryProgressGroupProps) => {
  return (
    <Stack sx={wrapperSx}>
      {Object.entries(progressBars).map(([group, counts]) => (
        <Stack key={group} sx={barGroupWrapperSx}>
          <Typography component="span" sx={barGroupTitleSx}>
            {group}
          </Typography>

          {LEVEL_KEYS.map((key, idx) => {
            if (key === 'total') return null;

            return (
              <Stack key={idx} sx={barWrapperSx}>
                <Typography component="span" sx={barNumberSx}>
                  {LIFE_READINESS_STRINGS.categoryCard[key]}
                </Typography>
                <ProgressBar progress={counts[key]} total={counts.total} />
              </Stack>
            );
          })}
        </Stack>
      ))}
    </Stack>
  );
};

const wrapperSx: SxProps<Theme> = ({ backrs }) => ({
  flexDirection: 'row',
  columnGap: backrs.spacing['spacing-4xl'],
  marginTop: backrs.spacing['spacing-2xl'],
});

const barGroupWrapperSx: SxProps<Theme> = {
  flexDirection: 'column',
  width: '100%',
};

const barWrapperSx: SxProps<Theme> = ({ backrs }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  columnGap: backrs.spacing['spacing-lg'],
});

const barNumberSx: SxProps<Theme> = ({ backrs, typography }) => ({
  color: backrs.colors['Colors/Text/text-secondary'],
  ...typography['text-sm-medium'],
});

const barGroupTitleSx: SxProps<Theme> = ({ backrs, typography }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
  marginBottom: backrs.spacing['spacing-sm'],
  textTransform: 'capitalize',
  ...typography['text-sm-regular'],
});
